<template>
  <div>
    <p v-if="status" class="lead--status">{{ stateLabel }}: {{ status.label }}</p>
    <sensitive-data-wrapper @click="openLeadModal">
      <h3 :class="['lead--line_1', {'is-large': isLarge}]" @click="openLeadModal">{{ address.line_1 }}</h3>
      <p class="lead--line_2">{{ address.line_2.trim() }}</p>
    </sensitive-data-wrapper>

    <record-icons
      v-if="!hideIcons"
      :record="record"
      class="mt-50 has-text-light"
      include-temp
    ></record-icons>
  </div>
</template>

<script>
import {ENUMS} from "../../services/enums";
import router from "../../router";
import SensitiveDataWrapper from "../SensitiveDataWrapper.vue";

export default {
  name: "RecordInfo",
  components: {SensitiveDataWrapper},
  props: {
    record: {
      type: Object,
      required: true,
    },
    status: Object,
    hideIcons: {
      type: Boolean,
      required: false,
    },
    isLarge: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    openLeadModal() {
      return router.replace({query: {lead: this.record.id}});
    },
  },
  computed: {
    address() {
      const property = this.record.property;
      const city = property.city ? property.city : '';
      const state = property.state ? property.state : '';
      const postcode = property.postcode ? property.postcode : '';
      const afterCity = property.city ? ", " : "";
      const afterState = property.state ? " " : "";

      return {
        line_1: property.line_1 ? property.line_1 : "Unknown Address",
        line_2: `${city} ${afterCity} ${state} ${afterState} ${postcode}`
      };
    },
    stateLabel() {
      return this.$utils.newGetEnumLabel(this.status.state, ENUMS.StatusStateEnum);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.lead {

  &--status {
    margin-bottom: 6px;
    color: $text-muted;
    font-size: 0.875rem;
  }

  &--line_1 {
    color: $link;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: $link-hover;
    }

    &.is-large {
      font-size: 1.25rem;
    }
  }

  &--line_2 {
    margin-top: 4px;
    font-size: 0.875rem;
  }

  &--expand_button {
    color: $link;
    cursor: pointer;

    &:hover {
      color: $link-hover;
    }

    &.is-expanded {
      transform: rotate(180deg);
    }
  }
}
</style>
